import TruckTable from "./TruckTable/index";

export default TruckTable;
